import { ComponentProps, ReactNode } from "react";

import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { badgeVariants } from "@fronterahealth/frontera-ui-components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@fronterahealth/frontera-ui-components/ui/tooltip";

interface FieldCountBadgeProps extends Omit<ComponentProps<"button">, "children" | "aria-label"> {
  count: number;
  label: string;
  icon: ReactNode;
}

export const FieldCountBadge: React.FC<FieldCountBadgeProps> = ({ count, label, icon, className, ...buttonProps }) => (
  <Tooltip>
    <TooltipTrigger
      render={<button type="button" aria-label={label} {...buttonProps} />}
      className={cn(badgeVariants({ variant: "outline", size: "sm" }), "cursor-pointer", className)}
    >
      {icon} {count}
    </TooltipTrigger>
    <TooltipContent>{label}</TooltipContent>
  </Tooltip>
);
